__turbopack_context__.v({
  "addon": "review-module__wKp1vq__addon",
  "card": "review-module__wKp1vq__card",
  "checkout": "review-module__wKp1vq__checkout",
  "deliverables": "review-module__wKp1vq__deliverables",
  "eyebrow": "review-module__wKp1vq__eyebrow",
  "heading": "review-module__wKp1vq__heading",
  "inputSummary": "review-module__wKp1vq__inputSummary",
  "linePrice": "review-module__wKp1vq__linePrice",
  "note": "review-module__wKp1vq__note",
  "order": "review-module__wKp1vq__order",
  "page": "review-module__wKp1vq__page",
  "photo": "review-module__wKp1vq__photo",
  "preferences": "review-module__wKp1vq__preferences",
  "reviewGrid": "review-module__wKp1vq__reviewGrid",
  "total": "review-module__wKp1vq__total",
});
